let appMode = process.env.REACT_APP_ENV;
let ASSET_URL = "https://b2btobacco.s3.amazonaws.com/";
let URL;

console.log("appMode", appMode);

// 3.20.147.34

if (appMode === "development") {
  // URL = "https://api.mylifesaver.in/api/";
  // URL = "http://localhost:8024/api/";
} else {
  URL = "https://api.mylifesaver.in/api/";
  // URL = "http://localhost:8024/api/";
}

let apiPath = {
  baseURL: URL,
  assetURL: ASSET_URL,
  dashboard: "admin/dashboard",
  graph: "admin/dashboard/user-graph-data",
  agreementGraph: "admin/dashboard/agreement-graph-data",

  // Auth API
  logout: "admin/auth/logout",
  login: "admin/auth/login",
  register: "admin/auth/register",

  profile: "admin/auth/get-profile",
  updateProfile: "admin/auth/update-profile",
  verifyOTP: "admin/auth/verify-otp",
  report: "admin/report/list",

  // User Management
  userList: "admin/auth/user-list",
  addUser: "admin/auth/add-user",
  updateUser: "admin/auth/update-user",
  updateUserStatus: "admin/auth/update-user-status",
  deleteUser: "admin/auth/delete-user",

  // Admin list (for Reporter dropdown in Sub Admin)
  adminList: "admin/auth/user-list",
  // Sub-Admin Management (users created by logged-in admin)
  subAdminList: "admin/sub-admin/list",
  addSubAdmin: "admin/sub-admin/add",
  updateSubAdmin: "admin/sub-admin/update",
  updateSubAdminStatus: "admin/sub-admin/update-status",

  // User Management (users created by logged-in admin, same as sub-admin flow)
  userManagementList: "admin/user-management/list",
  userManagementExport: "admin/user-management/export",
  addUserManagement: "admin/user-management/add",
  updateUserManagement: "admin/user-management/update",
  updateUserManagementStatus: "admin/user-management/update-status",
  deleteUserManagement: "admin/user-management/delete",
  locationDashboard: "admin/user-management/location-dashboard",
  getUserLocation: "admin/user-management/location",
  getNewLocations: "admin/new-location/list",
  getUserScreenTimeSummary: "admin/screen-time/summary",
  userManagementActivitySummary: "admin/user-management/activity-summary",
  attendanceRegisterExport: "admin/user-management/attendance-register/export",
  emailDataCountExport: "admin/user-management/email-data-count/export",
  distanceTravelledExport: "admin/user-management/distance/export",

  notificationUsers: "admin/notification-management/users",
  notificationHistory: "admin/notification-management/history",
  sendNotification: "admin/notification-management/send",
  notificationUploadImage: "admin/notification-management/upload-image",
  notificationShiftCronSettings:
    "admin/notification-management/shift-cron-settings",

  common: {
    countries: "",
    users: "/users",
    countries: "common/",
    cities: "",
    appSetting: "/app-setting",
  },

};

export default apiPath;
